import { render, staticRenderFns } from "./AsideFaleComAFael.vue?vue&type=template&id=3a5eca01&scoped=true&lang=pug&"
import script from "./AsideFaleComAFael.vue?vue&type=script&lang=js&"
export * from "./AsideFaleComAFael.vue?vue&type=script&lang=js&"
import style0 from "./AsideFaleComAFael.styl?vue&type=style&index=0&id=3a5eca01&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5eca01",
  null
  
)

export default component.exports